import Vue from 'vue';

export const evBus = new Vue();
